import { Component, ViewChild, OnInit, OnDestroy } from '@angular/core';
import { DialogHelper, HttpHelper } from 'nglhelper';
import { AuthService } from './common/services/authservice';
import { Router } from '@angular/router';
import { Version } from './appvariables';
import { LayoutService } from './common/services/layoutservice';
import { ActionProviderService } from './common/services/actionproviderservice';

@Component({
    templateUrl: './appshell.component.html',
    styleUrls: ['./appshell.component.scss']
})
export class AppShellComponent implements OnInit, OnDestroy {
    user;
    wsSub;
    version = Version;
    homeLink = "/sitemap";
    assetString;
    companyString;
    isSysAdmin = false;
    refreshInterval;
    constructor(
        private http: HttpHelper, 
        public auth: AuthService, 
        private dialog: DialogHelper, 
        private router: Router,
        public layout: LayoutService,
        public actionProvider: ActionProviderService 
    ){
        this.user = auth.User;
    }

    @ViewChild("menu") menu;
    async ngOnInit() {
        this.homeLink = "/sitemap";
        this.assetString = this.auth.GetAssetString();
        this.companyString = this.auth.GetCompanyString();
        this.isSysAdmin = this.auth.IsSysadmin();
        await this.actionProvider.initActionService();

        if (!this.refreshInterval) {
            this.refreshInterval = setInterval(() => {
                this.checkTokenExpiry();
            }, 10000);
        }
    }

    ngOnDestroy() {
        if (this.refreshInterval)
            clearInterval(this.refreshInterval);
    }

    async changePassword() {
        if (await this.dialog.Confirm("Changing password will logout from system. (Any unsave changes will be discarded.) Are you sure to continue? ")) {
            this.router.navigateByUrl('/changepassword');
        }
    }
    
    signout() {
        this.auth.SignOut();
        this.router.navigateByUrl("/login");
        this.dialog.ToastSuccess("Logout");
    }

    checkTokenExpiry(){
        if(this.auth.IsTokenExpired())
        {
            //prompt user to out
            this.dialog.AlertError("Session expired. Please login again.", "Session Expired!");
            this.auth.SignOut();
            this.router.navigateByUrl("/login");
        }
    }
}